import { render, staticRenderFns } from "./ComplaintInfoList.vue?vue&type=template&id=e0afb154&"
import script from "./ComplaintInfoList.vue?vue&type=script&lang=js&"
export * from "./ComplaintInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports